import {
  Button,
  Divider,
  Row,
  Select,
  Space,
  Popconfirm,
  Typography,
  Input,
  Card,
  Tag,
  ConfigProvider,
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import Checkbox from "@mui/material/Checkbox";
import React from "react";
import "./styles.css";
import { TrainingAPI } from "../../api/TrainingAPI";
import { formattedPlayerName } from "../../Utils/name_utils";
import { useSelector } from "react-redux";
import {
  AppstoreAddOutlined,
  UserOutlined,
  DeleteOutlined,
  CloseOutlined,
  FileFilled,
  FileTwoTone,
  FileOutlined,
} from "@ant-design/icons";
import "../../Styles/styles-Settings.css";
import { useDispatch } from "react-redux";
import {
  setTeamPlayerGroups,
  setTeamPlayers,
} from "../../store/actions/team.actions";
import { PermissionedInput, PermissionedButton, PermissionedSelect, PermissionedPopConfirm} from '../PermissionedComponents';
import { PermissionedCheckboxMUI } from "../PermissionedComponents/PermissionedComponents";

const { Search } = Input;
const { Title, Paragraph } = Typography;
const { CheckableTag } = Tag;

const trainingAPI = new TrainingAPI();

export const PlayerGrouping = () => {
  const dispatch = useDispatch();
  const { playerGroups, players } = useSelector(({ team }) => team);

  const inputRef = React.useRef(null);

  const handleCreateNewGroup = () => {
    if (!inputRef.current || !inputRef.current.input) {
      message.error("Input field is not available");
      return;
    }
    const newGroupName = inputRef.current.input.value;
    if (newGroupName === "") {
      message.info("Group name can't be empty.");
      return;
    }
    trainingAPI
      .createPlayerGroup(newGroupName)
      .then((data) =>
        dispatch(setTeamPlayerGroups([...playerGroups].concat(data)))
      )
      .catch((err) => message.error(err));
  };
  const handleDeleteGroup = (name) => {
    trainingAPI
      .deletePlayerGroup(name)
      .then((data) => {
        dispatch(
          setTeamPlayerGroups(playerGroups.filter((x) => x.name !== name))
        );
        message.success("Player group deleted.");
      })
      .catch((err) => {
        console.log(err);
        message.error("Error");
      });
  };

  const addPlayerToGroup = (player_id, group) => {
    let newPlayers = players.map((item) =>
      item?.player_id == player_id
        ? {
            ...item,
            player_groups: [...item?.player_groups, group.player_group_id],
          }
        : item
    );
    trainingAPI
      .updatePlayerGroupMapping(player_id, group.name, "add")
      .then((data) => {
        dispatch(setTeamPlayers(newPlayers));
      })
      .catch((err) => {
        message.error(err);
      });
  };

  const removePlayerFromGroup = (player_id, group) => {
    let newPlayers = players.map((item) => {
      if (
        item?.player_id == player_id &&
        item?.player_groups?.includes(group.player_group_id)
      ) {
        let idx = item?.player_groups?.indexOf(group.player_group_id);
        item?.player_groups.splice(idx, 1);
      }
      return item;
    });

    trainingAPI
      .updatePlayerGroupMapping(player_id, group.name, "del")
      .then((data) => {
        dispatch(setTeamPlayers(newPlayers));
      })
      .catch((err) => {
        message.error(err);
      });
  };

  const toggleIncludeInReport = (group) => {
    console.log(
      "clicked",
      "prev",
      group.included_in_report,
      "new",
      !group.included_in_report
    );
    trainingAPI
      .editPlayerGroup(group.name, undefined, !group.included_in_report)
      .then((data) => {
        dispatch(
          setTeamPlayerGroups(
            playerGroups.map((item) =>
              item.player_group_id == group.player_group_id ? data : item
            )
          )
        );
        message.success(
          `${group.name} will ${
            !group.included_in_report == false ? "not" : ""
          } be included in the reports`
        );
      })
      .catch((err) => {
        console.error(err);
        message.error("Error");
      });
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        margin: "24px 0px",
      }}
    >
      <div>
        <Paragraph>
          Create groups to filter players on the platform and your daily
          reports. <br />
          You can select which groups to include in your reports by toggling the{" "}
          <FileTwoTone /> button on the group. <br />
          If no groups are configured to be included in the reports, all active
          players will be included.
        </Paragraph>
      </div>
      <Space>
        <Space.Compact>
          <PermissionedInput 
            permissionCheck="AddPlayerGroups"
            placeholder="Add new Group" 
            ref={inputRef} 
          />
          <PermissionedButton
            permissionCheck="AddPlayerGroups"
            type="primary"
            icon={<AppstoreAddOutlined />}
            onClick={handleCreateNewGroup}
          />
        </Space.Compact>
      </Space>
      <Row
        style={{
          display: "flex",
          flexWrap: "wrap",
          // justifyContent: 'space-evenly',
          // border: '1px solid black',
          gap: "1em",
          marginTop: 16
        }}
      >
        {playerGroups.map((group, i) => (
          <>
            <Card
              extra={
                <>
                  <Tag style={{ border: "none" }} icon={<UserOutlined />}>
                    {
                      players.filter((item) =>
                        item?.player_groups?.includes(group.player_group_id)
                      ).length
                    }
                  </Tag>
                  <PermissionedPopConfirm
                    permissionCheck="DeletePlayerGroups"
                    placement="bottom"
                    title="Are you sure you want to delete this group?"
                    onConfirm={() => handleDeleteGroup(group.name)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <PermissionedButton 
                      permissionCheck="DeletePlayerGroups"
                      size={"small"} 
                      icon={<DeleteOutlined />}
                    />
                  </PermissionedPopConfirm>
                </>
              }
              title={
                <>
                  <div style={{ textAlign: "left" }}>
                    {group.name}
                    <PermissionedCheckboxMUI
                      permissionCheck="EditPlayerGroups"
                      size="large"
                      onChange={() => toggleIncludeInReport(group)}
                      checked={group.included_in_report}
                      icon={<FileOutlined style={{ color: "#ccc" }} />}
                      checkedIcon={<FileTwoTone />}
                    />
                  </div>
                </>
              }
            >
              <PermissionedSelect
                permissionCheck="EditPlayerGroups"
                placeholder="Add Player"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={filterOption}
                style={{ width: "100%" }}
                options={players
                  .sort((a, b) => a.first_name.localeCompare(b.first_name))
                  .map((item) => ({
                    value: item.player_id,
                    label: `${item.first_name} ${item.last_name} - ${item.position}`,
                  }))}
                onSelect={(player_id) => {
                  addPlayerToGroup(player_id, group);
                }}
              />
              <Divider />
              <div
                style={{
                  maxHeight: "10em",
                  overflowY: "scroll",
                  width: "20em",
                }}
              >
                {players
                  .filter((item) =>
                    item?.player_groups?.includes(group.player_group_id)
                  )
                  .map((item) => (
                    <>
                      <div
                        className="player-group-list-item"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          padding: "2px",
                        }}
                      >
                        <div>
                          {item.first_name} {item.last_name} - {item.position}
                        </div>
                        <div>
                          <PermissionedButton
                            permissionCheck="EditPlayerGroups"
                            size="small"
                            shape="circle"
                            type="text"
                            style={{
                              backgroundColor: "#fff",
                              marginRight: "0.5em",
                            }}
                            icon={
                              <CloseOutlined className="player-group-list-item-button" />
                            }
                            onClick={() => {
                              removePlayerFromGroup(item.player_id, group);
                            }}
                          />
                        </div>
                      </div>
                    </>
                  ))}
              </div>
            </Card>
          </>
        ))}
      </Row>
    </div>
  );
};
